module.exports = __webpack_public_path__ + "3c6a5b6ee4f87d9aad3e5642a5e74e8d.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/shop/golf-channel-hat.png
 ** module id = 473
 ** module chunks = 0
 **/